module.exports = __webpack_public_path__ + "img/banner.68c13c13.png";